import { Box, Typography } from '@mui/material';

const DotWave = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#4285f4' }}>
      Uploading
    </Typography>

    {[0, 150, 300].map((delay, i) => (
      <Box
        key={i}
        sx={{
          width: 8,
          height: 8,
          bgcolor: 'primary.main',
          borderRadius: '50%',
          animation: 'bounce 0.6s infinite',
          animationDelay: `${delay}ms`
        }}
      />
    ))}
  </Box>
);

export default DotWave;
